import { Component } from '@angular/core';

@Component({
  selector: 'app-sticky-footer',
  templateUrl: './sticky-footer.component.html',
  styleUrls: ['./sticky-footer.component.scss'],
  standalone: false
})
export class StickyFooterComponent {}
